
import { type Stem } from "@/types/stem";
import StemTrack from "@/components/StemTrack";

interface StemsListProps {
  stems: Stem[];
  originalUrl: string;
  onDownload: (stem: Stem) => void;
}

export const StemsList = ({ stems, originalUrl, onDownload }: StemsListProps) => {
  // Get duration from first stem since they all have the same duration
  const duration = stems.length > 0 ? stems[0].duration : 0;
  
  // Filter out the Original stem from the stems array since we'll render it separately
  const processedStems = stems.filter(stem => stem.name !== 'Original');

  return (
    <div className="space-y-2">
      <div className="bg-card rounded-lg">
        <StemTrack
          name="Original"
          audioUrl={originalUrl}
          onDownload={() => onDownload({ name: 'Original', url: originalUrl, duration })}
          index={0}
        />
      </div>
      {processedStems.map((stem, index) => (
        <div key={stem.name} className="bg-card rounded-lg">
          <StemTrack
            name={stem.name}
            audioUrl={stem.url}
            onDownload={() => onDownload(stem)}
            index={index + 1}
          />
        </div>
      ))}
    </div>
  );
};
